export default __webpack_public_path__ + "static/media/Card-BuyersEdge.94fbc54c.png";